import styled from "styled-components";
import { Formik, Form as FormikForm } from "formik";
import * as yup from "yup";
import axios from "axios";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const initialValues = {
  email: "",
  password: "",
};

const schema = yup.object().shape({
  email: yup.string().required("Login Phone is a required field!"),
  password: yup.string().required("Password is a required field!"),
});

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Phone or Username is required!";
  } else if (/^[0-9\b]+$/.test(values.email) === false) {
    errors.email = "Only number!";
  } else if (values.email.length !== 11) {
    errors.email = "Mobile Number contains 11 digit!";
  }

  if (!values.password) {
    errors.password = "Password is required!";
  } else if (values.password.length < 4) {
    errors.password = "Password is too short!";
  }
  return errors;
};

const LoginForm = () => {
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const Login_URL = process.env.REACT_APP_LOGIN_URL;
  const Login_Login_Post_URL = `${Base_URL}${Login_URL}`;
  const navigate = useNavigate();
  const [message, setMessage] = useState();

  const AddLoginFunc = async (values) => {
    let formfield = new FormData();

    // Append individual fields

    formfield.append("email", values.email);
    formfield.append("password", values.password);

    await axios({
      method: "POST",
      url: Login_Login_Post_URL,
      headers: {
        "Content-Type": "application/json; charset=UTF-8; text/plain",
      },
      data: formfield,
    })
      .then((response) => {
        localStorage.setItem("natureikoAccessToken", response.data.access);
        localStorage.setItem("natureikoRefreshToken", response.data.refresh);
        navigate("/");
        window.location.reload(false);
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.non_field_errors);
      });
  };

  const submitOrderForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddLoginFunc(values);
      setSubmitting(false);
      // resetForm();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  return (
    <Wrapper>
      <div className="container col-lg-6 col-md-6 col-sm-10 mobileView">
        <h3>Login Here</h3>
        <hr />
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={submitOrderForm}
          validate={validate}
        >
          {({
            handleSubmit,
            handleChange,
            isSubmitting,
            values,
            errors,
            touched,
          }) => (
            <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
              <div className="checkout-box">
                <div className="checkout-Login">
                  <Form.Group className="form-outline mb-4 ">
                    <Form.Label>
                      Phone<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="text"
                        name="email"
                        id="email"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={!!touched.email && !!errors.email}
                        isValid={touched.email && !errors.email}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 ">
                    <Form.Label>
                      Password<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="password"
                        name="password"
                        id="password"
                        value={values.password}
                        onChange={handleChange}
                        isInvalid={!!touched.password && !!errors.password}
                        isValid={touched.password && !errors.password}
                        className="form-control"
                        autoComplete="on"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>

              <div className="hstack gap-4 flex-wrap justify-content-center d-print-none my-4">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="normal"
                >
                  Login
                </button>
                <button className="normal">
                  <Link to="/register" style={{ textDecoration: "none" }}>
                    Register
                  </Link>
                </button>
              </div>
              <p
                style={{
                  textAlign: "center",
                  color: "red",
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              >
                {message}
              </p>
            </FormikForm>
          )}
        </Formik>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  form {
    max-width: 400px;
    margin: 0 auto;
  }

  div {
    margin-bottom: 15px;
  }

  label {
    display: block;
    margin-bottom: 5px;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 8px;
    margin-bottom: 8px;
    border: 1px solid black;
    border-radius: 4px;
  }

  label {
    font-weight: bold;
    margin-bottom: 10px !important;
  }

  span {
    color: red;
  }

  button,
  a {
    color: black;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button,
  a:hover {
    color: white;
  }

  .error {
    color: red;
    margin-top: 5px;
  }

  .container {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px green;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 80px;
  }

  @media (max-width: 477px) {
    .mobileView {
      width: 80%;
    }
  }
`;

export default LoginForm;
